import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, PRO_MEMBERSHIP} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {Card} from '@mui/material';
import {
  MembershipHeroSection,
  MembershipSlider,
  MembershipFeaturesSection,
} from '@jobseeker/feature-payment/components/Membership';
import 'swiper/css';
import 'swiper/css/navigation';
import type {GetServerSidePropsContext} from 'next/types';
import {InjectSearchOverlay} from '@components';
import {AppState} from '@jobseeker/common-core/types';

type ProMembershipProps = {
  seoConfig: object;
  queryParams: {
    recappid?: string;
    refcode?: string;
    pageid?: string;
  };
};

const ProMembership = ({seoConfig, queryParams}: ProMembershipProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, PRO_MEMBERSHIP);
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const {searchOverlay: isSearchEnabled} = useSelector(
    (state: AppState) => state?.app?.layout,
    shallowEqual
  );

  const breadcrumbElements = [
    {
      name: 'Home',
      item: '/',
    },
    {
      name: 'Pro-membership',
      item: ``,
    },
  ];

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
          <Card
            sx={{
              maxWidth: 1050,
              margin: '0 auto',
              borderRadius: '16px',
            }}
          >
            <MembershipHeroSection queryParams={queryParams} />
            <MembershipSlider />
            <MembershipFeaturesSection queryParams={queryParams} />
          </Card>
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const recappid = context.query?.recappid || null;
    const refcode = context.query?.refcode || null;
    const pageid = context.query?.pageid || null;

    const queryParams = {recappid, refcode, pageid};
    const seoConfig = await loadSEO(PRO_MEMBERSHIP);
    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: PRO_MEMBERSHIP},
    });
    return {
      props: {
        seoConfig,
        queryParams,
      },
    };
  }
);

export default ProMembership;
